import React, { Component } from "react";
import { Redirect } from "react-router-dom";

const confirmAuth = WrappedComponent => {
  return class extends Component {
    render() {
      if (!this.props.location.state || !this.props.location.state.confirmAuth) {
        return <Redirect to="/privacy/secure/your-data" />;
      }
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default confirmAuth;
